import { Dispatch, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/actions";
import BasicPhoneInput from "../../Components/Inputs/BasicPhoneInput";
import { errorMessage } from "../../util/Helpers";
import { useModal } from "../../Sliders/Modal/ModalContext";

const ORANGE = "#FF6A1A";
const NAVY = "#101535";

const Third = ({ setCurrPage, modalId }: any) => {
  const dispatch: Dispatch<any> = useDispatch();
  const { hideModal } = useModal();
  const loading = useSelector((state: any) => state.client.loading);
  const user = useSelector((state: any) => state.client.user);

  const [fullName, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [nameFocused, setNameFocused] = useState(false);

  useEffect(() => {
    if (user) {
      setFullname(user.fullname || "");
      setPhone(user.phone || "");
    }
  }, [user]);

  const handleSubmit = () => {
    dispatch(
      Actions.updateClient(
        { fullName, phone },
        () => {
          setCurrPage(1);
          hideModal(modalId);
        },
        () => errorMessage("Error")
      )
    );
  };

  const canSubmit = fullName.trim().length > 1 && phone.length > 6;

  return (
    <div className="flex flex-col h-full">
      {/* Heading */}
      <div style={{ marginBottom: 24, marginTop: 4 }}>
        <h2
          style={{
            fontFamily: '"Bricolage Grotesque", sans-serif',
            fontSize: 26,
            fontWeight: 700,
            color: NAVY,
            letterSpacing: -0.5,
            marginBottom: 6,
          }}
        >
          One last step
        </h2>
        <p style={{ color: "#6C7088", fontSize: 14, lineHeight: 1.6 }}>
          Complete your profile to finish setting up your account.
        </p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginBottom: 20 }}>
        {/* Phone — keep existing component, override wrapper */}
        <div>
          <label
            style={{
              display: "block",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: ".3px",
              textTransform: "uppercase",
              color: "#6C7088",
              marginBottom: 7,
            }}
          >
            Phone number
          </label>
          <div
            style={{
              borderRadius: 12,
              overflow: "hidden",
              border: "1.5px solid #E7E0D5",
              background: "#fff",
            }}
          >
            <BasicPhoneInput
              value={phone}
              label=""
              placeholder="e.g. +234 800 000 0000"
              onChange={(value: any) => setPhone(value)}
            />
          </div>
        </div>

        {/* Full name */}
        <div>
          <label
            style={{
              display: "block",
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: ".3px",
              textTransform: "uppercase",
              color: "#6C7088",
              marginBottom: 7,
            }}
          >
            Full name
          </label>
          <input
            type="text"
            value={fullName}
            placeholder="e.g. Adebayo Okafor"
            onChange={(e) => setFullname(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && canSubmit && handleSubmit()}
            onFocus={() => setNameFocused(true)}
            onBlur={() => setNameFocused(false)}
            style={{
              width: "100%",
              height: 52,
              background: "#fff",
              border: `1.5px solid ${nameFocused ? ORANGE : "#E7E0D5"}`,
              borderRadius: 12,
              padding: "0 16px",
              fontSize: 16,
              fontWeight: 500,
              color: NAVY,
              outline: "none",
              fontFamily: "inherit",
              boxSizing: "border-box",
              boxShadow: nameFocused ? "0 0 0 3px rgba(255,106,26,.1)" : "none",
              transition: "border-color .18s, box-shadow .18s",
            }}
          />
        </div>
      </div>

      {/* Save button */}
      <button
        type="button"
        onClick={handleSubmit}
        disabled={loading || !canSubmit}
        style={{
          width: "100%",
          height: 52,
          background: loading || !canSubmit ? "#E8C4A8" : ORANGE,
          color: "#fff",
          border: "none",
          borderRadius: 13,
          fontWeight: 700,
          fontSize: 15,
          cursor: loading || !canSubmit ? "not-allowed" : "pointer",
          fontFamily: "inherit",
          boxShadow: canSubmit && !loading ? "0 6px 20px -6px rgba(255,106,26,.5)" : "none",
          transition: "background .2s",
        }}
        onMouseOver={(e) => { if (!loading && canSubmit) (e.currentTarget as HTMLElement).style.background = "#E8550B"; }}
        onMouseOut={(e) => { if (!loading && canSubmit) (e.currentTarget as HTMLElement).style.background = ORANGE; }}
      >
        {loading ? "Saving…" : "Save & continue"}
      </button>
    </div>
  );
};

export default Third;
